goog.provide("shadow.js.shim.module$$dnd_kit$utilities");
goog.provide("module$shadow_js_shim_module$$dnd_kit$utilities");
shadow.js.shim.module$$dnd_kit$utilities = shadow.js.nativeProvides["@dnd-kit/utilities"] = shadow$bridge("@dnd-kit/utilities");
module$shadow_js_shim_module$$dnd_kit$utilities.default = shadow.js.shim.module$$dnd_kit$utilities;
